import {Typography, Link, Box} from '@material-ui/core'
import logo from "../images/branding/invoiage/invoiage-transparent-logo-small.png";

export default function InvoiageCopyright() {
    return (
        <Box mt={8}>
            <Typography variant="body2" color="textSecondary" align="center">
                {'Copyright © '}
                <Link rel="noopener noreferrer" target="_blank" color="inherit" href="https://invoiage.ai">
                Invoiage
                </Link>{' '}
                {new Date().getFullYear()}
                {''}
            </Typography>
            <a href="https://invoiage.ai" target="_blank" rel="noopener noreferrer">
                <img style={{marginTop: 20, height: 26, width: 102}}src={logo} />
            </a>
        </Box>
    );
  }